<div class="custom-color-picker">
  <div class="color-picker-arrow"></div>
  <div class="color-picker-header">
    {{'common.color_picker' | translate}}
  </div>
  <div class="color-picker-body">
    <span [style.background]="color"
          [cpToggle]="true"
          [cpWidth]="213"
          [cpOutputFormat]="'rgba'"
          [cpDialogDisplay]="'inline'"
          (colorPickerChange)="onChangeColorInput($event)"
          [(colorPicker)]="color"></span>
  </div>
  <div class="color-picker-footer d-flex flex-row flex-auto">
    <div class="reset-button d-flex flex-auto justify-content-start">
      <button type="button" (click)="onResetColor()">{{'common.btn.reset'| translate}}</button>
    </div>
    <div class="save-button d-flex justify-content-end">
      <button type="button" (click)="onSaveColor()">{{'common.btn.save'| translate}}</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-color-picker/achoo-color-picker.component.html